import { useEffect, useState } from "react";
import { ModalEditarLote } from "./containers/ModalEditarLote";
import { ResumoCriarLote } from "./containers/resumo";
import { IDadosCriarLote } from "../../interfaces/IDadosCriarLote";
import { ListarItensCriarLote } from "./containers/lista";
import { IPlanilhaCriarLote } from "../../interfaces/IPlanilhaCriarLote";
import { toastErro, toastSucesso } from "components/Toast";
import { ModalCertezaRemoverVeiculo } from "./containers/ModalCertezaRemoverVeiculo";
import { ModalCertezaAcaoVeiculo } from "./containers/ModalCertezaAcaoVeiculo";
import {
  validarChassi,
  validarPlaca,
  validarRenavam,
  validarUF,
} from "../../constants/lerPlanilha";
import { useBloqueioAdministrativo } from "../../hooks/useBloqueioAdministrativo";
import { ModalSucessoSalvarLote } from "./containers/ModalSucessoSalvarLote";
import { LoadingScreen } from "components/LoadingScreen";
import { IOptions } from "components/DropdownSelect";

interface IProps {
  dadosCriarLote: IDadosCriarLote;
  setDadosCriarLote: (dados: IDadosCriarLote) => void;
  dadosPlanilhaCriarLote: IPlanilhaCriarLote[];
  setDadosPlanilhaCriarLote: (dados: IPlanilhaCriarLote[]) => void;
  empresasOptions: IOptions[];
  cnpjsOptions: IOptions[];
  listarCnpjsIntegracaoFrotista: (idEmpresa: number) => void;
}

export function CriarLote({
  dadosCriarLote,
  setDadosCriarLote,
  dadosPlanilhaCriarLote,
  setDadosPlanilhaCriarLote,
  empresasOptions,
  cnpjsOptions,
  listarCnpjsIntegracaoFrotista,
}: IProps) {
  const [showEditarLote, setShowEditarLote] = useState<boolean>(false);
  const [showModalCertezaRemoverVeiculo, setShowModalCertezaRemoverVeiculo] =
    useState<boolean>(false);
  const [showModalCertezaAcaoVeiculo, setShowModalCertezaAcaoVeiculo] =
    useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<IPlanilhaCriarLote[]>([]);
  const [clearRows, setClearRows] = useState<boolean>(false);
  const [showModalSucessoCriarLote, setShowModalSucessoCriarLote] =
    useState<boolean>(false);

  const confirmarRemover = () => {
    if (!selectedRows.length) {
      toastErro("Selecione os veículos que deseja remover");
      return;
    }

    const renavamsSelecionados = selectedRows.map((item) => item.renavam);
    setDadosPlanilhaCriarLote(
      [...dadosPlanilhaCriarLote].filter(
        (item) =>
          !renavamsSelecionados.some((renavam) => renavam == item.renavam),
      ),
    );

    setSelectedRows([]);
    toastSucesso("Veículo(s) removido(s)");
  };

  useEffect(() => {
    setClearRows(!selectedRows.length);
  }, [selectedRows]);

  const handleClickAcaoVeiculo = async () => {
    const validacao = await checarValidadeDados();
    if (validacao.temErro) {
      toastErro(validacao.mensagem);
      return;
    }

    setShowModalCertezaAcaoVeiculo(true);
  };

  const checarValidadeDados = async (): Promise<{
    temErro: boolean;
    mensagem: string;
  }> => {
    let temErro = false;
    const erros: string[] = [];

    dadosPlanilhaCriarLote.map(async (linha) => {
      if (!validarPlaca(linha.placa)) {
        temErro = true;
        erros.push(
          `Placa inválida para este veículo (placa ${linha.placa ?? "--"}, renavam ${linha.renavam ?? "--"}, chassi ${linha.chassi ?? "--"})`,
        );
      }

      if (!validarRenavam(linha.renavam)) {
        temErro = true;
        erros.push(
          `Renavam inválido para este veículo (placa ${linha.placa ?? "--"}, renavam ${linha.renavam ?? "--"}, chassi ${linha.chassi ?? "--"})`,
        );
      }

      if (!validarChassi(linha.chassi)) {
        temErro = true;
        erros.push(
          `Chassi inválido para este veículo (placa ${linha.placa ?? "--"}, renavam ${linha.renavam ?? "--"}, chassi ${linha.chassi ?? "--"})`,
        );
      }

      if (!validarUF(linha.uf)) {
        temErro = true;
        erros.push(
          `UF inválida para este veículo (placa ${linha.placa ?? "--"}, renavam ${linha.renavam ?? "--"}, chassi ${linha.chassi ?? "--"})`,
        );
      }
    });

    return { temErro, mensagem: erros.join(". ") };
  };
  const { salvarLote, loading } = useBloqueioAdministrativo();
  const handleSalvarLote = async () => {
    setShowModalCertezaAcaoVeiculo(false);

    const { data, hasErro } = await salvarLote(
      dadosCriarLote,
      dadosPlanilhaCriarLote,
    );

    if (hasErro) {
      toastErro("Erro ao salvar lote");
      return;
    }

    setShowModalSucessoCriarLote(true);
  };

  return (
    <>
      <LoadingScreen mostrar={loading} />
      <ResumoCriarLote
        onClickAcaoVeiculo={handleClickAcaoVeiculo}
        onClickEditar={() => {
          setShowEditarLote(true);
        }}
        onClickRemover={() => {
          if (selectedRows.length >= dadosPlanilhaCriarLote.length) {
            toastErro("O lote deve conter pelo menos um processo.");
            return;
          }

          setShowModalCertezaRemoverVeiculo(true);
        }}
        desabilitarRemover={!selectedRows.length}
        resumo={dadosCriarLote}
      />
      <ListarItensCriarLote
        dados={dadosPlanilhaCriarLote}
        setDados={setDadosPlanilhaCriarLote}
        setSelectedRows={setSelectedRows}
        clearRows={clearRows}
      />
      <ModalEditarLote
        dadosCriarLote={dadosCriarLote}
        show={showEditarLote}
        handleClose={() => {
          setShowEditarLote(false);
        }}
        setDadosCriarLote={setDadosCriarLote}
        onConfirm={() => {
          toastSucesso("Alterações salvas");
          setShowEditarLote(false);
        }}
        empresasOptions={empresasOptions}
        cnpjsOptions={cnpjsOptions}
        listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
      />
      <ModalCertezaRemoverVeiculo
        show={showModalCertezaRemoverVeiculo}
        handleClose={() => setShowModalCertezaRemoverVeiculo(false)}
        onConfirm={confirmarRemover}
      />
      <ModalCertezaAcaoVeiculo
        show={showModalCertezaAcaoVeiculo}
        handleClose={() => setShowModalCertezaAcaoVeiculo(false)}
        onConfirm={handleSalvarLote}
        acao={dadosCriarLote.tipo}
      />
      <ModalSucessoSalvarLote
        show={showModalSucessoCriarLote}
        handleClose={() => {
          window.location.href = "/app/veiculo/bloqueio";
        }}
        tipo={dadosCriarLote.tipo}
      />
    </>
  );
}
